module.exports = __webpack_public_path__ + "static/better-logo-meta-fill-b191396431086bac53e19834b21abc7c.jpg";